import { styles } from './view/styles';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { WEB_COMPONENT_ACTION_ERROR } from '../../../../../webcomponents.constants';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { styleMap } from 'lit/directives/style-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement(WEB_COMPONENT_ACTION_ERROR)
export class GzActionErrorWebComponent extends LitElement {
  static get styles() {
    return styles;
  }
  @property({ type: Array, attribute: false, reflect: false })
  public errorMessages: Array<string>;

  /**
   * @type {number} textOffsetTop - this value provides the padding-top of the text element inside the 'gz-dialog-notification-content' component.
   * It is used to adjust the position of the text element in relation to the icon.
   */
  @property({ type: Number })
  textOffsetTop = 0;

  render() {
    return html`
      <gz-dialog-notification-content
        iconName="ds-icon-notification_negative_XL"
        iconColor="var(--red-layout-300-primary)"
        .textOffsetTop="${ifDefined(this.textOffsetTop)}"
      >
        <div slot="message">
          ${this.errorMessages.map(
            (errorMessage: string) => html`<gz-text fontSize="14">${unsafeHTML(errorMessage)}</gz-text>`
          )}
        </div>
      </gz-dialog-notification-content>
    `;
  }
}
